import { memo, useCallback } from 'react';

import { useTranslation } from 'react-i18next';

import { addTestAttribute } from '@shared/index';
import { RowContainer, WidgetHeader } from '@shared/ui';

import {
  NumberLabel,
  RemoveButton,
  TitleContainer,
} from './dynamic-form-title.styles';

interface DynamicFormTitleProps {
  title: string;
  index: number;
  buttonProps?: {
    label?: string;
    onClick?: (index: number) => void;
  };
  isRenderButton?: boolean;
  marginBottom?: number;
  testId?: string;
  isNewPath?: boolean;
}
export const DynamicFormTitle = memo(
  ({
    title,
    index,
    buttonProps,
    marginBottom,
    isNewPath,
    testId = 'form-title',
  }: DynamicFormTitleProps) => {
    const { t } = useTranslation();

    const { label: buttonLabel, onClick } = buttonProps || {};

    const handleOnClick = useCallback(
      (index: number) => () => {
        onClick?.(index);
      },
      [onClick]
    );

    return (
      <RowContainer
        $justify='space-between'
        $marginBottom={marginBottom || 0}
      >
        <TitleContainer>
          <NumberLabel $isNewPath={isNewPath}>{index + 1}</NumberLabel>
          <WidgetHeader>{title}</WidgetHeader>
        </TitleContainer>

        {onClick && (
          <RemoveButton
            size='s'
            variant='primary'
            onClick={handleOnClick(index)}
            {...addTestAttribute(`${testId}-remove-${index}`)}
          >
            {buttonLabel || t('COMMON:buttons.delete')}
          </RemoveButton>
        )}
      </RowContainer>
    );
  }
);
